import React from 'react'

import PleaseFilter from '../../../../PleaseFilter/PleaseFilter'
import Pagination from '../../../../UI/Pagination/Pagination'
import { Grid, CardContent } from '@material-ui/core'
import AppraisalCard from './AppraisalCard/AppraisalCard'

const CardList = ({
  records,
  selected,
  recordSelected,
  selectDisabled,
  pagination,
  pageChanged,
  perPageChanged,
  filtered,
  pagePermission,
  editButtonClicked,
  appraisalType
}) => {
  const cards = (records ?? []).map(record => (
    <AppraisalCard
      key={record.result_id}
      recordData={record}
      recordSelected={() => recordSelected(record.result_id)}
      checkDisabled={selectDisabled}
      checked={selected.includes(record.result_id)}
      appraisalType={appraisalType}
      editButtonDisabled={!pagePermission?.is_edit}
      editButtonClicked={() => editButtonClicked(record.result_id)}
    />
  ))
  let content = <PleaseFilter />
  if (filtered) {
    content = (
      <React.Fragment>
        <Grid container spacing={1} justify={'flex-start'}>
          {cards}
        </Grid>
        <Pagination
          pagination={pagination}
          pageChanged={pageChanged}
          perPageChanged={perPageChanged}
        />
      </React.Fragment>
    )
  }

  return <CardContent>{content}</CardContent>
}

export default CardList
